import React, { useState } from 'react';
import {
  Grid,
} from '@mui/material';
import KeypadButton from './KeypadButton';


const KeypadContainer = ({
  loading = false,
  canSubmit = false,
  onKeyPress = () => {},
  onSubmit = () => {},
  onBackspace = () => {},
}) => {
  return (
    <Grid container sx={{
      height: '100%',
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
    }}>
      <Grid container sx={{
        height: '25%',
        width: '100%',
      }}>
        <Grid item size={4}>
          <KeypadButton value={1} onClick={onKeyPress} disabled={loading} />
        </Grid>
        <Grid item size={4}>
          <KeypadButton value={2} onClick={onKeyPress} disabled={loading} />
        </Grid>
        <Grid item size={4}>
          <KeypadButton value={3} onClick={onKeyPress} disabled={loading} />
        </Grid>
      </Grid>
      <Grid container sx={{
        height: '25%',
        width: '100%',
      }}>
        <Grid item size={4}>
          <KeypadButton value={4} onClick={onKeyPress} disabled={loading} />
        </Grid>
        <Grid item size={4}>
          <KeypadButton value={5} onClick={onKeyPress} disabled={loading} />
        </Grid>
        <Grid item size={4}>
          <KeypadButton value={6} onClick={onKeyPress} disabled={loading} />
        </Grid>
      </Grid>
      <Grid container sx={{
        height: '25%',
        width: '100%',
      }}>
        <Grid item size={4}>
          <KeypadButton value={7} onClick={onKeyPress} disabled={loading} />
        </Grid>
        <Grid item size={4}>
          <KeypadButton value={8} onClick={onKeyPress} disabled={loading} />
        </Grid>
        <Grid item size={4}>
          <KeypadButton value={9} onClick={onKeyPress} disabled={loading} />
        </Grid>
      </Grid>
      <Grid container sx={{
        height: '25%',
        width: '100%',
      }}>
        <Grid item size={4}>
          <KeypadButton value='backspace' onClick={onBackspace} disabled={loading} />
        </Grid>
        <Grid item size={4}>
          <KeypadButton value={0} onClick={onKeyPress} disabled={loading} />
        </Grid>
        <Grid item size={4}>
          <KeypadButton value='enter' onClick={onSubmit} disabled={loading || !canSubmit} />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default KeypadContainer;